import { FC } from 'react';

import { SaveActionProps } from 'types/pages/audience-builder/shared/save';

import { useSaveActionConfiguration } from './hooks';

import cssClasses from './action.module.scss';

const SaveAction: FC<SaveActionProps> = (props) => {
  const component = useSaveActionConfiguration(props, cssClasses.saveActionIcon);

  return <>{component}</>;
};

export default SaveAction;
